import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import {
  Container, Content, Header, Info,
} from './css';
import NextPreviousButtons from '../../../../lib/ui/form_elements/NextPreviousButtons';
import AccessorialsPicker from '../../../../lib/ui/accessorialsPicker';

const Step3 = ({
  formData = {}, step, accessorialsList, nextStep, valid, dispatch, formName, lastStep,
}) => {
  const { measurementList } = formData;

  const isUSShipment = formData.USShipment;
  const shipperIsResidential = formData.shipperResidentialAddress;
  const consigneeIsResidential = formData.consigneeResidentialAddress;
  const hasDangerousGoods = measurementList && measurementList.some(({ itemDangerous }) => itemDangerous);

  if (step === 2) {
    return (
      <Container>
        <Header>
          <Info>
            {t('AdditionalChargesInfo')}
            {' '}
            ($)
          </Info>
          <NextPreviousButtons
            currentStep={2}
            totalSteps={lastStep}
            isValid={valid}
            nextObj={{
              label: t('Next'),
              action: nextStep,
              disabled: (!valid),
            }}
            onlyNext
            noMargins
          />
        </Header>
        <Content>
          <AccessorialsPicker
            source={accessorialsList}
            formName={formName}
            formData={formData}
            isUSShipment={isUSShipment}
            shipperIsResidential={shipperIsResidential}
            consigneeIsResidential={consigneeIsResidential}
            hasDangerousGoods={hasDangerousGoods}
            dispatch={dispatch}
          />
        </Content>
      </Container>
    );
  }

  return null;
};

Step3.propTypes = {
  formData: PropTypes.object,
  step: PropTypes.number,
  accessorialsList: PropTypes.object,
  nextStep: PropTypes.func,
  valid: PropTypes.bool,
  dispatch: PropTypes.func,
  formName: PropTypes.string,
  lastStep: PropTypes.number,
};

export default Step3;
